import Vue from "vue";
import Vuex from "vuex";
import Swal from "sweetalert2";
import { db } from "@/firebase";
import $ from "jquery";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    version: "0.0.0",
    usuario: null,
    async obtenerUsuario(id) {
      let usuario = null;
      usuario = await db
        .collection("usuarios")
        .doc(id)
        .get()
        .then((doc) => {
          if (doc.exists) {
            return doc.data();
          } else {
            return null;
          }
        })
        .catch(() => {
          return null;
        });
      return usuario;
    },
    async esperar(tiempo) {
      return new Promise((resolve) => {
        setTimeout(resolve, tiempo);
      });
    },
    alerta(tipo = "info", titulo = "", msg = "", error = "") {
      let contenido = "";
      if (tipo == "success" && msg != "") {
        contenido = `
        <div class="p-2 rounded border">
          <p style="color: #222"><b>📌 </b>${msg}</p>
        </div>
        `;
      } else if (tipo == "info" && msg != "") {
        contenido = `
        <div class="p-2 rounded border">
          <p style="color: #222"><b>📌 </b>${msg}</p>
        </div>
        `;
      } else if (tipo == "warning" && msg != "") {
        contenido = `
        <div class="p-2 rounded border">
          <p style="color: #222"><b style="color: rgb(255, 255, 255)">📌 </b>${msg}</p>
        </div>
        `;
      } else if (tipo == "question" && msg != "") {
        contenido = `
        <div class="p-2 rounded border">
          <p style="color: #222"><b>📌 </b>${msg}</p>
        </div>
        `;
      } else if (tipo == "error") {
        contenido = `
        <div>
          <textarea class="form-control rounded" rows="5" disabled>${error}</textarea><br>
          <p style="color: #222"><b>1.</b> Ha ocurrido un error en la operación, vuelve a intentarlo.</p>
          <p style="color: #222"><b>2.</b> Toma captura de pantalla o copia el texto del error para una solución más eficiente.</p>
          <p style="color: #222"><b>3.</b> Si el error persiste, comunícate con <a href="/soportetecnico" class="text-light font-weight-bold"><i class="fas fa-envelope-open-text"></i> Soporte Técnico</a></p>
        </div>
        `;
      }
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          popup: "swal-radius",
          confirmButton:
            "btn btn-primary w-100 text-capitalize h5 font-weight-bold",
        },
        buttonsStyling: false,
      });
      if (tipo === "success") {
        swalWithBootstrapButtons.fire({
          imageUrl: "/img/iconos/iconoSuccess.png",
          imageWidth: 90,
          imageHeight: 90,
          title: '<h4 style="color: #222">' + titulo + "</h4>",
          html: contenido,
          background: "rgb(243, 243, 243)",
          confirmButtonText: "Entendido",
          showConfirmButton: true,
          showCancelButton: false,
          reverseButtons: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      } else {
        swalWithBootstrapButtons.fire({
          icon: tipo,
          title: '<h4 style="color: #222">' + titulo + "</h4>",
          html: contenido,
          background: "rgb(243, 243, 243)",
          confirmButtonText: "Entendido",
          showConfirmButton: true,
          showCancelButton: false,
          reverseButtons: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });
      }
    },
    cerrarModal() {
      $("body").removeClass("modal-open");
      $(".modal-backdrop").remove();
    },
  },
  mutations: {},
  actions: {},
  modules: {},
});
